const fi = {
    common: {
        history: "historiallinen versio"
    }
};
export default fi;



// WEBPACK FOOTER //
// ./src/i18n/langs/fi.js